import React from 'react';
import PropTypes from 'prop-types';
import { CLASS_MOBILE_ONLY, SLIDER_WIDTH } from '../../const/responsive';
import { loaderCloudflareOriginal } from '../ImageWrapper';

import Styles from './HubBanner.module.scss';

function HubBanner({ src }) {
  const srcBanner = loaderCloudflareOriginal({ src, width: SLIDER_WIDTH });

  return (
    <div
      className={`${CLASS_MOBILE_ONLY} ${Styles.bannerHolder} mb-8`}
      style={{ backgroundImage: `url("${srcBanner}")` }}
    />
  );
}

HubBanner.propTypes = {
  src: PropTypes.string.isRequired,
};

export default HubBanner;
